/* eslint-disable no-restricted-imports */
import getValueByPathFromUnknown from 'integration/utils/getValueByPathFromUnknown';
import valueIsRecord from 'integration/utils/typeAssertions/valueIsRecord';
import valueIsString from 'integration/utils/typeAssertions/valueIsString';

// "/marcas-dportenis?offset=0&facet=manufacturer.raw%3A%22adidas%22"
// { pathname: 'marcas-dportenis', query: { offset: 0, facet: 'manufacturer.raw%3A%22adidas%22' } }
export const formatHref = (
	href: string
): {
	pathname: string;
	query: any;
} => {
	try {
		const _href = decodeURI(href);
		const [pathname, query] = _href.split('?');
		const queryParams = query?.split('&').map((param) => param.split('=')) ?? [];
		return { pathname, query: Object.fromEntries(queryParams) };
	} catch {
		if (valueIsString(href)) {
			return { pathname: href, query: {} };
		}

		const pathnameRaw = getValueByPathFromUnknown(href, ['pathname']);
		const queryRaw = getValueByPathFromUnknown(href, ['query']);

		const pathname = valueIsString(pathnameRaw) ? pathnameRaw : '/';
		const query = valueIsRecord(queryRaw) ? queryRaw : {};

		return { pathname, query };
	}
};
